export type QuantitieValues = 0 | 1 | 5 | 10 | 50 | -1;
export const quantities: { [key in string]: QuantitieValues } = {
  yokyo: 0,
  one: 1,
  five: 5,
  ten: 10,
  fifty: 50,
  all: -1,
};

export const oneQuantity: QuantitieValues[] = [quantities.one];
export const multiQuantities: QuantitieValues[] = [
  quantities.five,
  quantities.ten,
  quantities.fifty,
  quantities.all,
];

export type SceneType = "sei" | "otori" | "yokyo";
export const sceneTypes: { [key in string]: SceneType } = {
  正札モード: "sei",
  囮札モード: "otori",
  余興モード: "yokyo",
};
export type EventItemStatus = "release" | "soldout" | "cancel";
export const EventItemStatuses: { [key in EventItemStatus]: EventItemStatus } = {
    release: "release",
    soldout: "soldout",
    cancel: "cancel",
  };
